/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Refresh_TokensInputs */

const en_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh tokens`)
};

const ar_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رموز التحديث`)
};

const bn_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিফ্রেশ টোকেন`)
};

const de_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierungstoken`)
};

const es_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar tokens`)
};

const fr_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser les jetons`)
};

const pt_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar tokens`)
};

const zh_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新令牌`)
};

const tr_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belirteçleri yenile`)
};

const ru_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить токены`)
};

const pl_svchip_refresh_tokens = /** @type {(inputs: Svchip_Refresh_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odśwież tokeny`)
};

/**
* | output |
* | --- |
* | "Refresh tokens" |
*
* @param {Svchip_Refresh_TokensInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_refresh_tokens = /** @type {((inputs?: Svchip_Refresh_TokensInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Refresh_TokensInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_refresh_tokens(inputs)
	if (locale === "bn") return bn_svchip_refresh_tokens(inputs)
	if (locale === "de") return de_svchip_refresh_tokens(inputs)
	if (locale === "es") return es_svchip_refresh_tokens(inputs)
	if (locale === "fr") return fr_svchip_refresh_tokens(inputs)
	if (locale === "pt") return pt_svchip_refresh_tokens(inputs)
	if (locale === "zh") return zh_svchip_refresh_tokens(inputs)
	if (locale === "tr") return tr_svchip_refresh_tokens(inputs)
	if (locale === "ru") return ru_svchip_refresh_tokens(inputs)
	if (locale === "pl") return pl_svchip_refresh_tokens(inputs)
	return en_svchip_refresh_tokens(inputs)
});